// src/pages/NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';


const NotFound: React.FC = () => {
    return (
        <div id="notfound">
            <div className="notfound">
                <div className="notfound-404">
                    <h1>Oops!</h1>
                </div>
                <div className='mt-3'>
                    <h2>404 - Page not found</h2>
                    <p style={{ fontSize: '18px' }}>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;